(function() {

    angular
    .module('ngmvac')
    .service('CouponService', CouponService);

    function CouponService() {
        var coupon = null;

        return {
            set: set,
            validate: validate
        }

        function set(coupon) {
            coupon = coupon;
        }

        function validate(hotel) {
            
        }

    }

})();